import {createUseStyles} from 'react-jss';
import MediaQueries from '../../../../../v2/style-helper/MediaQueries';
import baseInputStyles from '../../../../../v2/form/Form.styles';

export default createUseStyles({
  
  billingSelectionField: {
    display: 'flex',
    padding: [0, 30, 0, 0],
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    backgroundColor: 'transparent',
    border: 'transparent',
    backgroundPosition: '98% 0%',
    
    // Custom styled select for Webkit based browser only
    [MediaQueries.webkit]: {
      appearance: 'none',
    },
    
    '&:invalid': {
      color: '#bbb',
    },
    
    '&.error-block-v2': {
      '&:invalid': {
        color: '#b60000',
      },
    },
  },
  
  billingAddressSelectionField: {
    ...baseInputStyles,
    height: 50,
    padding: [4, 0, 45, 8],
  },
  
  header: {
    fontWeight: 'bold',
    fontSize: '90%',
  },
});
